<div class="edit-payment-date-dialog">
  <header class="dialog-header">
    <div class="dialog-header__icon" aria-hidden="true">
      <i-tabler name="calendar-time"></i-tabler>
    </div>
    <div class="dialog-header__text">
      <h2 mat-dialog-title>Fecha de pago programada</h2>
      <p class="dialog-header__context">OS N° {{ displayedOrderNumber }}</p>
    </div>
  </header>

  <ng-container *ngIf="viewState === 'form'">
    <mat-dialog-content class="dialog-body">
      <div *ngIf="!canEditOrder" class="alert alert--error">
        <i-tabler name="ban" class="alert-icon"></i-tabler>
        <span>{{ blockedMessageText }}</span>
      </div>

      <div class="co-field-group">
        <div class="co-field-group__header">
          <label class="co-field-group__label" for="edit-scheduledPaymentDate">
            Nueva fecha
          </label>
          <span class="co-field-badge co-field-badge--required"
            >Obligatorio</span
          >
        </div>
        <div
          class="co-date-field"
          [class.co-date-field--disabled]="!canEditOrder"
        >
          <input
            id="edit-scheduledPaymentDate"
            class="co-date-field__input"
            [matDatepicker]="fechaPagoProgramadaPicker"
            [formControl]="fechaPagoProgramadaInput"
            placeholder="dd/mm/aaaa"
            autocomplete="off"
            readonly
            (click)="canEditOrder && fechaPagoProgramadaPicker.open()"
          />
          <button
            type="button"
            class="co-date-field__icon"
            (click)="fechaPagoProgramadaPicker.open()"
            [disabled]="!canEditOrder"
            aria-label="Abrir calendario"
          >
            <mat-icon>event</mat-icon>
          </button>
          <mat-datepicker
            #fechaPagoProgramadaPicker
            panelClass="os-datepicker-panel"
          ></mat-datepicker>
        </div>
        <p class="co-field-group__hint">
          Formato DD/MM/AAAA. Debes indicar una fecha válida para guardar.
        </p>
        <p
          *ngIf="
            fechaPagoProgramadaInput.touched && fechaPagoProgramadaInput.invalid
          "
          class="co-field-group__error"
        >
          Ingresa una fecha válida.
        </p>
      </div>
    </mat-dialog-content>

    <mat-dialog-actions class="dialog-actions">
      <button
        mat-stroked-button
        type="button"
        class="co-btn co-btn--ghost"
        (click)="handleCancel()"
      >
        Cancelar
      </button>
      <button
        mat-flat-button
        type="button"
        class="co-btn co-btn--primary"
        [disabled]="
          !canEditOrder ||
          fechaPagoProgramadaInput.invalid ||
          isSubmittingRequest
        "
        (click)="updateFechaPagoProgramada()"
      >
        <mat-spinner *ngIf="isSubmittingRequest" [diameter]="18"></mat-spinner>
        <span *ngIf="!isSubmittingRequest">Guardar</span>
      </button>
    </mat-dialog-actions>
  </ng-container>

  <ng-container *ngIf="viewState === 'error'">
    <mat-dialog-content class="dialog-body">
      <div class="alert alert--error">
        <i-tabler name="alert-triangle" class="alert-icon"></i-tabler>
        <div>
          <strong *ngIf="errorTitleText">{{ errorTitleText }}</strong>
          <span>{{ errorMessageText }}</span>
        </div>
      </div>
      <p class="co-field-group__hint">
        La vista puede estar desactualizada. Al continuar se consultará de nuevo
        el backend.
      </p>
    </mat-dialog-content>

    <mat-dialog-actions class="dialog-actions">
      <button
        mat-flat-button
        type="button"
        class="co-btn co-btn--primary"
        (click)="handleCloseAndRefresh()"
      >
        Entendido y actualizar
      </button>
    </mat-dialog-actions>
  </ng-container>
</div>
